import React, { FC } from 'react';
import { Box, Button } from '@mui/material';
import CustomButton from 'shared/custom-button/CustomButton';
import { RoutesType } from 'shared/types/routes/routers-type';
import { useNavigate } from 'react-router-dom';
import styles from 'features/create-task/ui/Answer.module.css'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
interface IAnswer {
    number: string;
    id: string;
    idContract: string | null;
    saveAsDraft: boolean;
}

const Answer: FC<IAnswer> = ({
    number,
    id,
    idContract,
    saveAsDraft
}) => {

    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`${RoutesType.TaskCase}/?id=${id}`, {
            state: {
                textRout: 'applications',
                name: 'Заявки'
            }
        });
    }

    const handleClickBack = () => {
        if (idContract) {
            navigate(`/insurance-contracts/case/?id=${idContract}`, {
                state: {
                    textRout: 'insurance-contracts',
                    name: 'Договоры страхования',
                    activeTab: 2
                }
            });
        } else {
            navigate(`${RoutesType.TasksList}`, {
                state: {
                    textRout: 'applications',
                    name: 'Заявки'
                }
            });
        }
    };

    return (
        <Box className={styles.pageContainer}>
            <Box className={styles.answerBox}>
                <Box className={styles.iconBox}><CheckCircleOutlineIcon /></Box>
                {saveAsDraft ? (
                    <h2 className={styles.answerTitle}>Проект заявки сохранен!</h2>
                ) : (
                    <>
                        <h2 className={styles.answerTitle}>Ваша заявка успешно отправлена!</h2>
                        <p>Заявка <span className={styles.numberTask}>{number}</span> уже в работе.</p>
                        <p>Статус исполнения заявки можно посмотреть в разделе "Заявки"</p>
                    </>
                )}
                <Box className={styles.btnBox}>
                    <CustomButton
                        handleClick={handleClick}
                        title='Перейти к заявке'
                        textColor="white"
                        backgroundColor="#0054E6"
                        padding="5px 30px"
                        gap="10px"
                        border='none'
                        borderRadius='4px'
                    />
                    <Button onClick={handleClickBack} className={styles.btnBack}><KeyboardBackspaceIcon /> {idContract ? "Назад к договору" : 'Назад к списку заявок'}</Button>
                </Box>
            </Box>
        </Box>
    );
};

export default Answer;